import Axios from "./index";
import { parseFilters } from "./helper";

export const indexNotifications = params => {
  return Axios.get(`/user/notifications`, { params: parseFilters(params) });
};
